import { render, staticRenderFns } from "./AppCookiePolicy.vue?vue&type=template&id=5c765394&scoped=true&"
import script from "./AppCookiePolicy.vue?vue&type=script&lang=js&"
export * from "./AppCookiePolicy.vue?vue&type=script&lang=js&"
import style0 from "./AppCookiePolicy.vue?vue&type=style&index=0&id=5c765394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c765394",
  null
  
)

export default component.exports